"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("../src/Client"));
const generated_1 = require("../src/ua/generated");
const NodeId_1 = require("../src/ua/NodeId");
const id_1 = require("../src/id/id");
const client = new Client_1.default();
client.addEventListener('session:activate', async (event) => {
    console.log(event);
    const req = new generated_1.BrowseRequest({
        NodesToBrowse: [
            new generated_1.BrowseDescription({
                NodeId: NodeId_1.NewTwoByteNodeId(id_1.IdRootFolder),
                BrowseDirection: generated_1.BrowseDirectionBoth,
                IncludeSubtypes: true,
                // NodeClassMask: BrowseResultMaskAll
                ResultMask: generated_1.BrowseResultMaskAll
            })
        ]
    });
    const res = await client.browse(req);
    console.log('awaited');
    console.log(res);
});
